import FractionDsnNom from '@/generated/controls/fractionDsn/FractionDsnNom.vue';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: FractionDsnNom
})

